import { Route } from "react-router-dom";
import PodcastCreate from "./pages/PodcastCreate";
import PodcastList from "./pages/PodcastList";

/**
 * This will return all routes for the specific module
 */
const MODULE_ROUTE = "podcast"; 
const PodcastRoute = [
    <Route path={`${MODULE_ROUTE}`} element={<PodcastList />} key={`${MODULE_ROUTE}_index`} />,
    <Route path={`${MODULE_ROUTE}/create`} element={<PodcastCreate />}  key={`${MODULE_ROUTE}_create`}  />,
    <Route path={`${MODULE_ROUTE}/update/:podcast_id`} element={<PodcastCreate />} key={`${MODULE_ROUTE}_edit`} />,
  ];

export default PodcastRoute;